<template>
    <div class="bg-white">
        <Head>
            <title>Правила перебування на озерах Хвиля</title>
        </Head>
        <Header :cart-count="cartCount"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <h2 class="page-title">Доставка і оплата</h2>
            <h3 class="text-2xl mt-8">Доставка:</h3>
            <p class="my-4 leading-7">
                Ми надсилаємо квитки на пошту, яку ви вказали під час замовлення.
                Також квитки можна забрати безпосередньо на водоймі перед риболовлею
            </p>
            <h3 class="text-2xl mt-8">Оплата:</h3>
            <p class="my-4 leading-7">
                Ми приймаємо оплату онлайн за допомогою банківських карт Visa та Mastercard.
                Оплата здійснюється через безпечний протокол SSL, що гарантує захист ваших особистих даних.
                Вартість квитків на нашому сайті вказана в українських гривнях (UAH).
                У разі відмови від замовлення, гроші будуть повернені на вашу банківську картку протягом 5-7 робочих днів.
                Ми робимо все можливе, щоб забезпечити вам максимальний комфорт при замовленні квитків на нашому сайті. Якщо у вас виникли питання або пропозиції, будь ласка, зв’яжіться з нами за допомогою контактної форми на сторінці “Контакти”. Наші менеджери з задоволенням вам допоможуть.
            </p>
            <p class="my-4 leading-7">
                Озеро "Хвиля"
                Озеро «Хвиля» знаходиться в селі Ступки,
                зовсім недалеко від міста Суми,
                за «Лебединською» Ворожбою.
            </p>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Header from "@/Component/Header.vue";
export default {
    components: {
        Header,
        Head,
    },
    props: {
        cartCount: Number
    }
}
</script>
